import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'iposcen-ipos-help-standard-ipos',
  templateUrl: './ipos-help-standard-ipos.component.html',
  styleUrls: ['./ipos-help-standard-ipos.component.scss']
})
export class IposHelpStandardIposComponent implements OnInit {
  @Output() sideNav = new EventEmitter();
  loginUserRole = sessionStorage.getItem('userRole');
  constructor() { }

  ngOnInit(): void {
  }

  navigate(){
    this.sideNav.emit(['installationProcess', '', '']);
  }

}
